import { Api } from "@/api";
import { UserLoginType } from "@/DTO";

export const CreatePublisher = (user: UserLoginType, name: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `publisher`,
      body: JSON.stringify(
        {
          name: name
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};